import * as React from "react"
import {useEffect} from "react"

import { BANNERS_ROUTES} from "@constants"
import PageWrapper from "Pages/@PageWrapper"
import {isSystemBusy,} from "@signals";
import {resetBannersDetailsSignals, bannersDetailsHasLimit, bannersDetailsIsEmpty} from "./@signals";
import BannersDetailsFilters from "./Filters";
import BannersDetailsTable from "./Table";


export default function BannersDetailsPage() {

    useEffect(() => {
        return () => resetBannersDetailsSignals()
    }, []);

    const LIMIT_SEARCHES = [{
        title: "Over 1000 results found",
        message: 'You can download the Excel file to view all results, but please be aware that it may take some time to generate the Excel file.',
        severity: 'warning'
    }]

    return <PageWrapper
        head={`DIP Insight | ${BANNERS_ROUTES.BANNERS_DETAILS_TITLE}`}
        title={BANNERS_ROUTES.BANNERS_DETAILS_TITLE}
        subtitle={BANNERS_ROUTES.BANNERS_DETAILS_SUBTITLE}
        filters={<BannersDetailsFilters />}
        isEmpty={bannersDetailsIsEmpty.value}
        hasErrors={isSystemBusy.value}
        globalMessages={bannersDetailsHasLimit.value && LIMIT_SEARCHES}
    >
        <BannersDetailsTable />
    </PageWrapper>
}
